__turbopack_context__.v({
  "burger": "fvF9dG_burger",
  "burgerContainer": "fvF9dG_burgerContainer",
  "buttonsContainer": "fvF9dG_buttonsContainer",
  "hidden": "fvF9dG_hidden",
  "inverse": "fvF9dG_inverse",
  "left": "fvF9dG_left",
  "logo": "fvF9dG_logo",
  "menuGroup": "fvF9dG_menuGroup",
  "menuLabel": "fvF9dG_menuLabel",
  "menuOptions": "fvF9dG_menuOptions",
  "modal": "fvF9dG_modal",
  "modalBody": "fvF9dG_modalBody",
  "modalClose": "fvF9dG_modalClose",
  "modalCloseContainer": "fvF9dG_modalCloseContainer",
  "modalContainer": "fvF9dG_modalContainer",
  "modalContent": "fvF9dG_modalContent",
  "modalFooter": "fvF9dG_modalFooter",
  "modalHeader": "fvF9dG_modalHeader",
  "navContent": "fvF9dG_navContent",
  "navContentBurger": "fvF9dG_navContentBurger",
  "navmenuContainer": "fvF9dG_navmenuContainer",
  "open": "fvF9dG_open",
  "wrapper": "fvF9dG_wrapper",
});
